module.exports = __webpack_public_path__ + "static/media/modal-bg-family.1d99c00e.png";